import LanguagesTable from "./languages-table";

export default LanguagesTable;